<artemis-customers-batch-upload-history></artemis-customers-batch-upload-history>
<div class="right-side">
  <artemis-user-notifications-component *ngIf="!defaultUsersCardActive" (defaultUsersSaved)="toggleUsersCards()" [showResetButton]="false">
  </artemis-user-notifications-component>
  <div class="default-users-card" *ngIf="defaultUsersCardActive">
    <artemis-loading-spinner *ngIf="defaultUsersListLoading$ | async"></artemis-loading-spinner>
    <div class="default-users-card__content-container">
      <div class="default-users-card__btn-container">
        <button mat-button class="btn btn_rounded btn_small default-users-card__toggle-btn" ubi-round-button
                (click)="updateDefaultSettings()">
          UPDATE DEFAULT USER NOTIFICATION SETTING
        </button>
        <button mat-button class="btn btn_accent-gradient-rounded btn_small default-users-card__toggle-btn" ubi-round-button
                (click)="toggleUsersCards()">
          CHANGE USER NOTIFICATION OF THIS CUSTOMER
        </button>
      </div>
    </div>
  </div>
  <artemis-customers-batch-upload [isFileProcessing]="isFileProcessing | async" (processFile)="processFile($event)"></artemis-customers-batch-upload>
</div>
